import { DataBroker } from './DataBroker';


function GetShiurIndex(date) {
	const TodayDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	const FirstDate = new Date(1984, 4-1, 28);
	const DaysDiff = Math.round((TodayDate.getTime() - FirstDate.getTime()) / (1000 * 3600 * 24));


	let diff = (DaysDiff % 339);
	return (diff === 0) ? 339 : diff;
};

export async function GetR3(gregDate) {
	const Shiur3 = GetShiurIndex(gregDate);
	const Shiur1 = Shiur3 * 3;

	let files = [(Shiur1-2), (Shiur1-1), (Shiur1)];

	if (Shiur3 === 36)
		files = [106, 107, 108.1];
	
	else if (Shiur3 === 37)
		files = [108.2, 109, 110];
	
	else if (Shiur3 >= 38 && Shiur3 <= 55) 
		files = [(Shiur1-3), (Shiur1-2), (Shiur1-1)];
	
	else if (Shiur3 === 56)
		files = [(Shiur1-3), (Shiur1-2), (Shiur1-1), (Shiur1)];
	

	let data = "";
	let loaded = true;

	for (let i=0; i<files.length; i++) {
		let tmpData = await DataBroker.getDataText('r/' + files[i]);
		
		if (tmpData === null)
			loaded = false;

		if (tmpData.indexOf('|') !== -1) {
			const Parts = tmpData.split('|');

			if (i===0)
				data += Parts[0];

			data += Parts[1];
		}
		else
			data += tmpData;
	}

	return new Promise((myResolve, myReject) => {
		if (!loaded)
			myReject(DataBroker.getError());
		else
			myResolve(<div className='Rambam' dangerouslySetInnerHTML={{ __html: data }} />);
	});
};